import React, { PropsWithChildren } from "react";

import { Card, Title } from "@amphore-dev/amphore-lib";
import { Link } from "react-router-dom";

export interface IAuthLayoutProps extends PropsWithChildren {
	title?: string | boolean;
}

export const AuthLayout: React.FC<IAuthLayoutProps> = ({ children, title }) => {
	// Not amphore-lib's Modal: it's a fixed dark scrim with no way to
	// override it (no overlayClassName-equivalent in V2), but this "floating
	// card" is meant to stay transparent so the background image behind it
	// shows through — so it's built directly on Card (what Modal's own
	// panel is built on) instead, with no overlay at all.
	return (
		<div className="relative h-full overflow-auto">
			<div className="pointer-events-none fixed inset-0 z-10 flex items-center justify-center overflow-y-auto p-4">
				<Card
					elevation={4}
					className="pointer-events-auto m-auto w-full max-w-sm shadow-xl [&>div:first-child:empty]:hidden"
				>
					<Link
						to={"/"}
						className="menu-item flex w-full flex-col items-center justify-center gap-6 gap-y-4 overflow-hidden rounded-3xl py-4 text-2xl no-underline!"
					>
						<img
							src="/assets/logo.svg"
							alt="logo"
							className="pointer-events-none h-16 w-16"
						/>
						<div>C H R O N O S</div>
					</Link>
					{title && (
						<Title className="mb-4 w-full text-center" size="h3">
							{title || "Welcome"}
						</Title>
					)}
					{children}
				</Card>
			</div>
			<div className="fixed top-0 left-0 z-0 flex h-full max-h-full w-full items-center justify-center">
				<div
					className="h-full min-h-full w-full max-w-[min(90%,1500px)] bg-cover bg-center bg-no-repeat"
					style={{
						backgroundImage:
							"url(/assets/backgrounds/auth-background.svg)",
						backgroundSize: "90% 90%",
					}}
				/>
			</div>
		</div>
	);
};
